// extracted by mini-css-extract-plugin
export default {"button":"button_button__VWeAX","button__label":"button_button__label__ALOZN"};